import React from 'react'
import NewsList from './NewsList'
import { withLocalize } from 'react-localize-redux';
import { Translate } from 'react-localize-redux';

 function News(props) {
    let langCode = "en";
    if (props.activeLanguage !== undefined) {
      langCode = props.activeLanguage.code;
    }

    return (
    <div>
        
        <div class="card card-bottom-tabs m-b-10">
        <div class="card-block">
            <h4 class="card-title m-t-0"><Translate id="general.NewsTitle"/></h4>
            
        </div>
        </div> 
        <NewsList Lang={langCode }/>
    </div>
    )
}
export default withLocalize(News)



// WEBPACK FOOTER //
// ./src/pages/News/News.js